import { importExportApi } from "./index";

export const enum ImportTypes {
  CourseV1JSON = "course_v1_json",
  CourseV2JSON = "course_v2_json",
  UserCSV = "user_csv",
  StudentCSV = "student_csv",
  ContractorCSV = "contractor_csv",
  LaborProtectionWorkerImport = "labor_protection_worker_import"
}

export interface ImportListParams {
  ids?: Array<string>;
  companyId?: string;
  type?: ImportTypes;
  createdAtMin?: Date;
  createdAtMax?: Date;
  startedAtMin?: Date;
  startedAtMax?: Date;
  finishedAtMin?: Date;
  finishedAtMax?: Date;
  status?: "waiting" | "started" | "success" | "fail";
  offset?: number;
  limit?: number;
  sort?: "createdAt" | "startedAt" | "finishedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export const list = (params: ImportListParams, options?: any) => {
  return importExportApi.Import.listImports(
    params.ids,
    params.companyId,
    params.type,
    params.createdAtMin,
    params.createdAtMax,
    params.startedAtMin,
    params.startedAtMax,
    params.finishedAtMin,
    params.finishedAtMax,
    params.status,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.options
  );
};
